module.exports = __webpack_public_path__ + "img/ayuda-indetec.06fc90e5.svg";